import { calendarConstants } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse"
import APIService from "../../helper/api-service";
import { ICalenderEvents } from "../../models/common/ICalendar";


export default new (class calendarService {
  public getCalendarEvents = async (startDateTime: string, endDateTime: string, userEmail: string): Promise<IApiResponse<ICalenderEvents>> => {
    try {
      let endPoint = urlBinder(calendarConstants.GET_OUTLOOK_CALENDAR_EVENTS, [startDateTime, endDateTime, userEmail]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ICalenderEvents>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ICalenderEvents>;
      } else {
        throw error;
      }
    }
  };

  public getGoogleCalendarEvents = async (startDateTime: string, endDateTime: string, userEmail: string): Promise<IApiResponse<ICalenderEvents>> => {
    try {
      let endPoint = urlBinder(calendarConstants.GET_GOOGLE_CALENDAR_EVENTS, [startDateTime, endDateTime, userEmail]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ICalenderEvents>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ICalenderEvents>;
      } else {
        throw error;
      }
    }
  };

})();